import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="modern-loading-container">
      <div className="loading-card">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <h3 className="loading-title">Loading Tips Magnets</h3>
        <p className="loading-subtitle">Preparing your professional tip interface...</p>
      </div>
    </div>
  );
};

export default Loading;
